class SiteLicenseUser {
  constructor(data) {
    this.memberId = data.memberId
    this.name = data.name
    this.email = data.email
    this.status = data.status
    this.statusId = data.statusId
    this.invitationId = data.invitationId
    this.canBeRevoked = data.canBeRevoked
    this.canRemove = data.canRemove
    this.canRemoveInvitation = data.canRemoveInvitation
    this.canResendInvitation = data.canResendInvitation
    this.canSendNewInvitation = data.canSendNewInvitation
  }
}
export default SiteLicenseUser
